<!-- 拆开套包后的商品入仓操作弹框- -->
<template>
  <div class="warehouseOut" v-loading="dailogLoading">
    <div class="dialog-header">
      <div>
        <el-button
          v-if="!isTcrkModel"
          class="btn-primary"
          size="small"
          @click="isTcrkModel = true"
          >同仓入库</el-button
        >
        <el-select
          v-if="isTcrkModel"
          v-model="tcrkWarehouseId"
          size="small"
          filterable
          clearable
          @visible-change="track_wHVisibleChange($event)"
          @change="(val)=>{tcrkShelfSpaceId='',tcrkShelfSpaceOptions=[]}"
          style="margin-right: 20px"
        >
          <el-option
            v-for="optionItem in trackWarehouseList"
            :label="optionItem.WarehouseName"
            :value="optionItem.WarehouseId"
            :key="optionItem.WarehouseId"
          >
          </el-option>
        </el-select>
        <el-select
          v-if="isTcrkModel"
          v-model="tcrkShelfSpaceId"
          :loading="loading"
          filterable
          clearable
          reserve-keyword
          remote
          :remote-method="(value) => tcrkRemoteMethod(value, tcrkWarehouseId)"
          @visible-change="(value) =>{if(value&&tcrkShelfSpaceOptions.length==0)tcrkRemoteMethod('', tcrkWarehouseId)}"
          size="small"
        >
          <el-option
            v-for="item in tcrkShelfSpaceOptions"
            :key="item.ShelfSpaceId"
            :label="item.ShelfSpaceCode"
            :value="item.ShelfSpaceId"
          >
          </el-option>
        </el-select>
      </div>
      <div v-if="isTcrkModel">
        <el-button size="small" @click="isTcrkModel = false">取消</el-button>
        <el-button class="btn-primary" size="small" @click="tcrkSubmitData"
          >入仓</el-button
        >
      </div>
    </div>
    <div class="tips">商品入库到同一仓位下</div>    
    <div class="warehouseOut-main">
      <div class="table-main">
        <el-table
            :data="goodsList"
            :span-method="objectSpanMethod"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%;">
            <!-- <el-table-column type="selection" v-if="isTcrkModel"></el-table-column> -->
            <el-table-column prop="GoodName" label="配件名称" width="180"></el-table-column>
            <el-table-column prop="APCode" label="配件编码" width="180"></el-table-column>
            <el-table-column prop="WarehouseId" label="仓库">
                <template slot-scope="scope">
                    <el-select
                    v-model="scope.row.WarehouseId"
                    size="small"
                    filterable
                    clearable
                    :loading="loading"
                    reserve-keyword 
                    @visible-change="wHVisibleChange($event,scope.row)"
                    @change="warehouseChange($event,scope.row)"
                    :disabled="isTcrkModel"
                    >
                    <el-option
                        v-for="(optionItem,index) in scope.row.WarehouseList"
                        :label="optionItem.WarehouseName"
                        :value="optionItem.WarehouseId"
                        :key="index"
                    ></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column prop="ShelfSpaceId" label="仓位">
                <template slot-scope="scope">
                    <el-select
                    v-model="scope.row.ShelfSpaceId"
                    :loading="loading"
                    filterable
                    clearable
                    remote
                    reserve-keyword
                    :remote-method="
                            (val) =>
                            remoteMethod(val, scope.row)
                        "
                    @visible-change="positionVisibleChange($event,scope.row)"  
                    @change="positionChange($event,scope.row)"
                    no-data-text="无存放仓位"
                    no-match-text="无存放仓位"                
                    size="small"
                    :disabled="isTcrkModel"
                    >
                    <el-option
                        v-for="optionItem in scope.row.ShelfSpacesList"
                        :key="optionItem.index"
                        :label="optionItem.ShelfSpaceCode"
                        :value="optionItem.ShelfSpaceId"
                    >
                    <span style="display:inline-block;width: 150px">{{optionItem.ShelfSpaceCode}}</span>
                        <span>库存:{{optionItem.Count}}</span>
                    </el-option>
                    </el-select>
                </template>
            </el-table-column>                  
           <el-table-column prop="Count" label="数量" width="100">
               <template slot-scope="scope">
                    <el-input
                    size="small"
                    type="number"
                    v-model="scope.row.Count"
                    :max="scope.row.CountMax"
                    :min="0"
                    :disabled="isTcrkModel"
                    ></el-input>   
               </template>
           </el-table-column>
           <el-table-column  label="操作" width="120">
               <template slot-scope="scope">
               <el-button size="mini" icon="el-icon-minus" @click="delItem(scope.$index,scope.row)" :disabled="isTcrkModel"></el-button>
                <el-button
                    size="mini"
                    icon="el-icon-plus"
                    @click="addItem(scope.$index,scope.row)"
                    :disabled="isTcrkModel"
                ></el-button>
               </template>
           </el-table-column>
            </el-table>
      </div>
    </div>
    <div class="dialog-footer" v-if="!isTcrkModel">
      <el-button size="small" @click="cancel" :disabled="dailogLoading">取消</el-button>
      <el-button class="btn-primary" size="small" :disabled="dailogLoading" @click="submitData()">入仓</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: ["APList"],
  components: {},
  data() {
    return {
      dailogLoading:true,
      loading: false,
      searchPositionReq:{
          WarehouseId:"",
          ShelfSpaceCode: "",
          GoodsId: "",
          SortField: "Count",
          SortType:"asc",
          MustIn:false,
          Page:1,
          Limit:10
      } ,      
      formData: {
        SReturnId: this.SReturnId,
        GoodsList: [
          {
            EntpTempGoodsId: "",
            GoodsLocationList: [
              {
                ShelfSpaceId: "",
                Count: ""
              }
            ]
          }
        ]
      },
      goodsList: [],
      isTcrkModel: false, // 是否开启同仓入库模式
      tcrkWarehouseId: "", // 同仓入库仓库信息
      tcrkShelfSpaceId: "", // 同仓入库仓位信息
      trackWarehouseList:[],
      tcrkShelfSpaceOptions: [], // 同仓入库仓位列表      
      spanArr: [],
      pos: 0,
      multipleSelection:[],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init(){
      let that = this;
      //处理入仓数据 
      let _APList = [];
      for (let i = 0; i <that.APList.length;i++){
            _APList.push({
                EntpTempGoodsId:that.APList[i].EntpTempGoodsId,
                GoodName:that.APList[i].GoodName,
                APCode:that.APList[i].APCode,
                Count:that.APList[i].Count,
                CountMax:that.APList[i].Count,
                ShelfSpaceId:"",
                ShelfSpacesList:[],
                WarehouseId:"",
                WarehouseList: [],
            });
        }
        that.goodsList = _APList;
        that.getSpanArr();
        that.dailogLoading=false;
    },
    cancel() {
      this.$emit("closeDialog");
    },
    submitData(dataList) {
      let that = this;
      dataList=!dataList?[]:dataList;
      if(dataList.length==0){
        for (let i = 0; i < that.goodsList.length; i++) {
          let PV = Number(that.goodsList[i].CountMax);
          if (!that.goodsList[i].ShelfSpaceId) {
              that.$util.warningMsg("请选择仓位");
              return;
          }
          let intCount=Number(that.goodsList[i].Count)
          if(intCount<=0){
              that.$util.warningMsg('入库数量必须大于零')
              return
          }
          let goods= dataList.find(f=>f.EntpTempGoodsId==that.goodsList[i].EntpTempGoodsId);
          if(goods){
            goods.GoodsLocationList.push({ShelfSpaceId:that.goodsList[i].ShelfSpaceId,Count:intCount});
          }else{
              goods={
                  EntpTempGoodsId:that.goodsList[i].EntpTempGoodsId,
                  CountMax:PV,
                  GoodsLocationList:[{ShelfSpaceId:that.goodsList[i].ShelfSpaceId,Count:intCount}],
              };
              dataList.push(goods);
          }          
        }
        let isreturn=false;
        dataList.forEach((goods)=>{
          let sumValue =goods.GoodsLocationList.reduce(function(sum,e){
              return sum +e.Count;
          },0);  
          if(sumValue!=goods.CountMax) {
              that.$util.warningMsg("入库数量不等于可存放数量");
              isreturn=true;
              return ;
          }   
        });
        if(isreturn)return ;
      }

      that.dailogLoading=true;
      that.formData.GoodsList =dataList;
      that.$util
        .axiosPost({
          url:
            "/api/EntpGoods/StoreGoodsAfterSeparateSets",
          data: that.formData,
          hideLoading:true,
        })
        .then(res => {
          that.$util.successMsg("入仓成功");
          that.$emit("closeDialog");
        }).catch(()=>{this.dailogLoading=false;});
    },
    // 同仓入库-入库按钮
    tcrkSubmitData() {
      let that = this;  
      if (!that.tcrkWarehouseId) {
        that.$util.warningMsg("请选择仓库");
        return;
      }
      if (!that.tcrkShelfSpaceId) {
        that.$util.warningMsg("请选择仓位");
        return;
      }
      // let sel=that.multipleSelection;
      // if(sel.length==0){
      //   that.$util.warningMsg("请选择入仓的商品");
      //   return;         
      // }

      // let dataList=[];
      // sel.forEach((e,i)=>{
      //     let same=dataList.find(f=>f.EntpTempGoodsId==e.EntpTempGoodsId);
      //     if(!same){
      //       let g=that.APList.find(f=>f.EntpTempGoodsId==e.EntpTempGoodsId);
      //       if(g){
      //           dataList.push({
      //               EntpTempGoodsId:e.EntpTempGoodsId,
      //               GoodsLocationList:[{ShelfSpaceId:that.tcrkShelfSpaceId,Count:g.Count}]
      //           });
      //       }             
      //     }
      // }); 
      let dataList=[];
      that.APList.forEach((e,i)=>{
          dataList.push({
              EntpTempGoodsId:e.EntpTempGoodsId,
              GoodsLocationList:[{ShelfSpaceId:that.tcrkShelfSpaceId,Count:e.Count}]
          });
      }); 
      that.submitData(dataList);
    },
    //仓库下拉框出现/隐藏时触发
    wHVisibleChange(val, goods) {
      if (!val) return;
      let that = this;
      if (!goods.WarehouseList || goods.WarehouseList.length <=1) {
        that.loading = true;
        that.$util.getWarehouseByGId(goods.EntpTempGoodsId,false).then((data) => {
          let newW=data;
          let w=goods.WarehouseList.length>0?goods.WarehouseList[0]:"";
          if(w){
          let exit=data.find(e=>e.WarehouseId==w.WarehouseId);
            if(!exit){
              newW=goods.WarehouseList.concat(newW);
            }
          }
          that.$set(goods, "WarehouseList", newW);
          that.loading = false;
        });
      }
    },     

    //仓位下拉框出现/隐藏时触发
    positionVisibleChange(val, goods) {
      if (!val || !goods.WarehouseId) return;
      let that = this;
      if (
        !(goods.ShelfSpacesList && goods.ShelfSpacesList.length > 0)
      ) {
            that.searchPositionReq.WarehouseId=goods.WarehouseId;
            that.searchPositionReq.ShelfSpaceCode="";
            that.searchPositionReq.GoodsId=goods.EntpTempGoodsId;
            that.searchPositionReq.Page=1;
            that.searchPosition(that.searchPositionReq).then((resp) => {
            let newArr=[];
            if(resp.data)newArr=resp.data;          
            that.$set(goods, "ShelfSpacesList", newArr);
            that.loading = false;
            });
      }
    },
    remoteMethod(val, goods) {
      if (!val || !goods.WarehouseId) return;
      let that = this;
      that.searchPositionReq.WarehouseId=goods.WarehouseId;
      that.searchPositionReq.ShelfSpaceCode=val;
      that.searchPositionReq.GoodsId=goods.EntpTempGoodsId;
      that.searchPositionReq.Page=1;   
      that.searchPosition(that.searchPositionReq).then((resp) => {
        let newArr=[];
        if(resp.data)newArr=resp.data;
        that.$set(goods, "ShelfSpacesList", newArr);
        that.loading = false;
      });
    },

    track_wHVisibleChange(val){
       if (!val||this.trackWarehouseList.length>0) return;
       this.$util.getWarehouse().then((data) => {
        this.trackWarehouseList = data;
      });       
    },
    // 同仓入库搜索仓位
    tcrkRemoteMethod(value, tcrkWarehouseId) {
      if (!tcrkWarehouseId) return;
      let that = this;
      that.loading = true;
      that.$util
        .GetShelfSpacesList({
            WarehouseId: tcrkWarehouseId,
            ShelfSpaceCode: value,
            Limit: 20,
            IsLimit: true,
            IncludecWaste:true
        })
        .then((res) => {
          that.loading = false;
          if (res.data) {
            that.tcrkShelfSpaceOptions = res.data;
          } else {
            that.$util.warningMsg("该仓库暂无仓位");
          }
        })
        .catch((error) => {
          that.loading = false;
        });
    },        
    // 搜仓位
    searchPosition(req) {
     let that = this;
      if (!req.WarehouseId || that.loading) return;
      that.loading = true;
      return that.$util.getPositionByGId(that.searchPositionReq);
    },
    warehouseChange(value, goods) {
        goods.ShelfSpacesList = [];
        goods.ShelfSpaceId = "";
    },
    positionChange(value, goods) {
        if (!value) return;
        var that=this;
        var filterArr=that.goodsList.filter(e=>e.EntpTempGoodsId==goods.EntpTempGoodsId&&e.ShelfSpaceId==value);
        if(filterArr.length>1){
            goods.ShelfSpaceId="";
            this.$util.warningMsg("不能选相同仓位");
            return;
        } 
    },    
    delItem(index,goods) {
        let that=this;
        var filterArr=that.goodsList.filter(e=>e.EntpTempGoodsId==goods.EntpTempGoodsId);
        if(filterArr.length>1)
        {
            that.goodsList.splice(index, 1);
            that.getSpanArr();
        }
    },
    addItem(index,goods) {
      let that=this;
      let _target = that.goodsList;
      let usedCount=0;//已选数量
      for (let i = 0; i < _target.length; i++) {
        if(_target[i].EntpTempGoodsId==goods.EntpTempGoodsId){
            if (!_target[i].ShelfSpaceId) {
            that.$util.warningMsg("请选择仓位");
            return;
            }
            if (!_target[i].Count || !_target[i].Count < 0) {
            that.$util.warningMsg("请填写正确的数量");
            return;
            }
           usedCount+=Number(_target[i].Count);
        }
      }
      //当前商品可出库数量
      let canInCount=Number(goods.Count);
      //剩余数量
      let surplus=canInCount-usedCount       
      that.goodsList.splice(index+1,0,{
        EntpTempGoodsId:goods.EntpTempGoodsId,
        GoodName:goods.GoodName,
        APCode:goods.APCode,
        Count: surplus>0?surplus:0,
        CountMax:goods.CountMax,
        WarehouseId: goods.WarehouseId,
        ShelfSpaceId: "",
        ShelfSpacesList: [...goods.ShelfSpacesList],
        WarehouseList: [...goods.WarehouseList],
      });
      that.getSpanArr();
    },
    getSpanArr() {
      this.spanArr=[];
      this.pos = 0;
      for (var i = 0; i < this.goodsList.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (this.goodsList[i].EntpTempGoodsId === this.goodsList[i - 1].EntpTempGoodsId) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },   
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0|| columnIndex === 1) {
            const _row = this.spanArr[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
            // [0,0] 表示这一行不显示， [2,1]表示行的合并数
            rowspan: _row,
            colspan: _col,
            };      
        }
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
  }
};
</script>
<style lang="less" scoped>
.add-btn {
  position: absolute;
  right: 10px;
  bottom: 6px;
}
.ops-ctn {
  text-align: left !important;
}
.dialog-header {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tips {
  color: #f00;
  margin-top: 4px;
  margin-left: 4px;
}
.dialog-footer {
  text-align: right;
}
.warehouseOut-main {
  padding: 20px 0;
}
.table-title {
  .cell-item {
    width: 33.33%;
  }
  .div-table-cell {
    text-align: center;
    height: 30px;
    line-height: 30px;
  }
}
.div-table-row {
  position: relative;
  overflow: visible;
}
.table-main {
  .div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .cell-line {
    display: flex;
    width: 100%;
  }
  .cell-item {
    padding: 0 10px;
    width: 33%;
    width: inherit;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
}
</style>
